import React from "react"

const BlogPostFormField = ({ label, description, children, required = false }) => (
  <div className="relative w-full border-b border-builder-border-light pb-6">
    <div className="mb-6 max-w-[800px]">
      <p className="text-base font-bold leading-6 text-builder-primary">
        {label}
        {required && <span className="text-red">*</span>}
      </p>
      {description && <p className="mt-0.5 text-sm leading-5 text-builder-secondary">{description}</p>}
    </div>
    <div className="max-w-[800px]">{children}</div>
  </div>
)

export default BlogPostFormField
